













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'list-item' })
export default class ListItemComponent extends Vue {
  @Prop() public label!: string;
}
